import React, { useEffect } from 'react';
import { Link } from 'react-router-dom';
import SplitType from 'split-type';
import gsap from 'gsap';
import '../index.css';

function Hero() {
    useEffect(() => {
        
        const splitText = new SplitType('.wtg', { types: 'words' });

        
        gsap.from(splitText.words, {
            opacity: 0,
            y: 40,
            duration: 1,
            stagger: { amount: 0.5 },
        });

       
        const words = document.querySelectorAll('.word');

        
        words.forEach((word) => {
            const tween = gsap.to(word, { yPercent: -30, yoyo: true, repeat: 1, paused: true });

            const handleMouseOver = () => {
                if (!gsap.isTweening(word)) {
                    tween.restart();
                }
            };

            word.addEventListener('mouseover', handleMouseOver);

            return () => {
                word.removeEventListener('mouseover', handleMouseOver);
            };
        });

    }, []);

    return (
        <div className="hero-bg my-0 h-[100vh] h-[100dvh]">
            <div className="bg-transparent overflow-y-scroll snap-y snap-mandatory">
                <div className="hero-content w-screen h-[100vh] h-[100dvh] flex justify-center items-end py-10 snap-center pb-32" id="target">
                    <h1 className="text-white text-center font-bold md:text-8xl text-4xl sm:text-5xl lg:text-9xl pb-20 pt-32 sm:pt-64 w-full wtg">
                        Towards a greener blue.
                    </h1>
                </div>
                <div className="hero-content h-[100vh] h-[100dvh] text-white text-center w-screen flex flex-col items-center snap-center pt-32">
                    <h2 className="mb-16 md:text-8xl text-4xl sm:text-5xl font-custom font-bold">ABOUT US</h2>
                    <div className="flex-grow"></div>
                    <p className="text-lg sm:text-2xl md:text-3xl lg:px-44 px-6 sm:px-10 mb-12">
                        Founded in November 2023, the <span className="font-custom font-bold">FEUP Academic Solar Team</span> is a project involving students from various engineering degrees from Faculdade de Engenharia da Universidade do Porto (FEUP), Portugal. Our mission is to merge innovation with sustainability by developing a solar-powered competition vessel and address key technological challenges in the field, sailing on the power of the sun.
                    </p>
                    <Link
                        to="/departments"
                        className="w-fit px-5 py-2.5 bg-white text-slate-900 font-bold rounded-full hover:bg-mainBlue hover:text-white transition-all duration-300 hover:scale-105 font-custom mb-32"
                    >
                        Meet our team
                    </Link>
                </div>
            </div>
        </div>
    );
}

export default Hero;
